import axios from "axios";
import { gatewayUrl } from "@Constants/gatewayUrl";
import { createConfig } from "@Utils/createConfig";
import { LEGACY_LANGUAGE_CODES } from "@juristic/types/generic/language";
export async function getLanguage(token) {
    const header = createConfig(token);
    const url = `${gatewayUrl}/language`;
    const res = await axios.get(url, header);
    return LEGACY_LANGUAGE_CODES[res.data] ?? res.data;
}
